"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogin = void 0;
const ui_1 = require("@rahtab/ui");
const enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
const hmac_sha256_1 = __importDefault(require("crypto-js/hmac-sha256"));
const moment_jalaali_1 = __importDefault(require("moment-jalaali"));
const react_1 = require("react");
const TokenAuthContext_1 = __importDefault(require("./TokenAuthContext"));
const helpers_1 = require("./helpers");
const useFetchCallType_1 = __importDefault(require("./useFetchCallType"));
const useLogin = () => {
    const [challengeTime, setChallengeTime] = react_1.useState(moment_jalaali_1.default());
    const [credentials, setCredentials] = react_1.useState();
    const alert = ui_1.useAlert();
    const { handleSuccessfulLogin, roleVersion, client } = react_1.useContext(TokenAuthContext_1.default);
    const [getServerChallenge, { data: serverChallenge, loading: getChallengeLoading }] = useFetchCallType_1.default('GetServerChallenge', {
        useAuthJson: false,
        skip: false,
        onCompleted: () => setChallengeTime(moment_jalaali_1.default()),
    });
    let params = `UserName=${helpers_1.fixNumbers(credentials?.username)}&Digest=${credentials?.digest}`;
    if (roleVersion === 'multi')
        params += '&RoleVersion=Multi';
    const [_login, { loading: loginLoading }] = useFetchCallType_1.default('Login', {
        useAuthJson: false,
        params,
        skip: !credentials?.digest,
        async onCompleted(loginData) {
            setCredentials(undefined);
            if (Array.isArray(loginData) || (typeof loginData === 'object' && loginData.LoginSuccess)) {
                const tickets = Array.isArray(loginData) ? loginData : loginData.Tickets;
                const viewerEntityList = Array.isArray(loginData)
                    ? undefined
                    : loginData.EntityTypes.map((item) => ({
                        typeCode: item.EntityTypeCode,
                        label: item.EntityTypeName,
                        name: item.EntityName,
                        selected: loginData.EntityTypes.length === 1,
                    }));
                if (viewerEntityList) {
                    await helpers_1.setViewerEntityList(viewerEntityList);
                }
                const sessionToken = hmac_sha256_1.default(serverChallenge?.toString() || '', helpers_1.fixNumbers(credentials?.password)).toString(enc_base64_1.default);
                const session10 = sessionToken.slice(0, 10);
                await client.setKey(session10);
                await client.addTickets(tickets);
                await helpers_1.setUsername(credentials?.username || '');
                handleSuccessfulLogin();
            }
            else {
                alert({
                    title: 'خطا',
                    message: 'نام کاربری یا رمز عبور نادرست است.',
                });
            }
        },
    });
    react_1.useEffect(() => {
        if (!credentials || !serverChallenge)
            return;
        const challengeDiffTime = moment_jalaali_1.default().diff(challengeTime, 'minutes');
        if (challengeDiffTime > 5) {
            getServerChallenge();
            return;
        }
        const digest = encodeURIComponent(hmac_sha256_1.default(helpers_1.fixNumbers(credentials?.password), serverChallenge?.toString() || '').toString(enc_base64_1.default));
        setCredentials({ ...credentials, digest });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [credentials?.username, credentials?.password, serverChallenge]);
    const login = async (username, password) => {
        if (!username || !password)
            return;
        setCredentials({ username, password });
    };
    return {
        /** @deprecated always returns false */
        getChallengeLoading: false,
        loginLoading: getChallengeLoading || loginLoading,
        login,
    };
};
exports.useLogin = useLogin;
